import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "truncate" })
export class TruncatePipe implements PipeTransform {
  transform(value: string | null | undefined, limit = 10): string {
    if (!value || value.length <= limit) {
      return value ?? "";
    }

    return `${value.slice(0, limit)}...`;
  }
}
